module.exports = __webpack_public_path__ + "trends_active.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/trends_active.svg
// module id = 112
// module chunks = 0